import { lazy } from 'react';

const AsyncMailerTemplatesListPage = lazy(() => import('./ListContainer'));

export const MailerTemplatesList = () => {
  return <AsyncMailerTemplatesListPage />;
};
